import './bank-external-qr.scss';

import { QRCode } from 'antd';
import { type FC, useEffect, useState } from 'react';

import { Button, Modal } from '@/components/Shared/ui';
import { BankNames } from '@/constants';
import useToggle from '@/hooks/useToggle';
import DownloadIcon from '@/media/icons/file-download.svg?react';
import QrCodeIcon from '@/media/icons/qr.svg?react';
import { handleError } from '@/services/handleError';
import { sanitizeFileName } from '@/services/helpers/strings';
import { useAppSelector } from '@/store';

const BankExternalQr: FC = () => {
  const { selectedBank } = useAppSelector((state) => state.financingStep);

  const [qrUrl, setQrLink] = useState<string | null>(null);
  const modalOpenState = useToggle();

  const downloadSvgQRCode = () => {
    if (!selectedBank) return;

    try {
      const canvas = document
        .getElementById('bank-external-qr')
        ?.querySelector<HTMLCanvasElement>('canvas');

      if (!canvas) throw new Error('Canvas not found');

      const url = canvas.toDataURL();

      const link = document.createElement('a');
      link.href = url;
      link.download = sanitizeFileName(
        `QR-код для подписания ${selectedBank.bank.fullname}.jpg`
      );
      link.click();
      link.remove();
    } catch (error) {
      handleError(error, {
        customTitle: 'Не удалось скачать QR-код'
      });
    }
  };

  useEffect(() => {
    modalOpenState.setOff();

    if (!selectedBank) return;
    try {
      if (selectedBank.bank.name === BankNames.shinhan) {
        const { qr: qrUrl } = JSON.parse(
          selectedBank.responseSendedBody || '{}'
        );
        setQrLink(new URL(qrUrl).href);
      }
    } catch (error) {
      handleError(error, {
        notify: false,
        onError: () => {
          setQrLink(null);
        }
      });
    }

    return () => {
      setQrLink(null);
      modalOpenState.setOff();
    };
  }, [selectedBank]);

  if (!qrUrl) return null;
  return (
    <>
      <Button
        size="small"
        fullWidth
        className="chosen-bank-info__action"
        onClick={modalOpenState.setOn}
      >
        <QrCodeIcon className="bank-external-qr__icon" />{' '}
        <span className="chosen-bank-info__action-hidden">
          QR-код для подписания
        </span>
      </Button>
      <Modal
        title="QR-код для подписания"
        centered
        open={modalOpenState.isOn}
        onClose={modalOpenState.setOff}
        maskClosable={false}
        width={400}
        classNames={{
          mask: 'bank-external-qr__modal-wrapper'
        }}
      >
        <div className="bank-external-qr__modal-content" id="bank-external-qr">
          <QRCode
            type="canvas"
            value={qrUrl}
            size={500}
            style={{ width: '100%', height: '100%' }}
          />
          <div className="bank-external-qr__actions">
            <Button
              type="button"
              onClick={downloadSvgQRCode}
              size="small"
              variant="filled-black"
              fullWidth
            >
              <DownloadIcon className="bank-external-qr__download-icon" />
              Скачать QR-код
            </Button>
            <Button
              type="button"
              onClick={modalOpenState.setOff}
              size="small"
              variant="outlined"
              fullWidth
            >
              Закрыть
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BankExternalQr;
